import React from 'react';
import {
  Icon, Card, Image, Label, Grid,
} from 'semantic-ui-react';
import util from 'utils/utils';
import { MultiLineParagraph } from 'components/lib/UI';
import { UserChip } from 'components/lib/Chips';
import RichTextViewer from 'components/lib/Editors/RichTextViewer';
import Video from 'components/lib/Video/Video';
import styled from 'styled-components';
import { overviewComponents } from './Body/Contents';

export const Slide = styled.div`
  position:absolute;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
  opacity:0.0;
  z-index:10;
  overflow-x: hidden;
  overflow-y: scroll;
  background:white;
  transition:opacity 0.5s;
  &.shown{
    opacity:1.0;
    z-index:15;
  }
  .cover{
    background-size:cover;
    background-position:center center;
  }
  .slide-content {
    margin:0px 20px;
  }
  table{
    width:100% !important;
    td{
      border:1px solid rgb(200,200,200);
    }
  }
  img{
    max-width:100%;
  }
  video{
    max-width:100%;
  }
  iframe{
    max-width:100%;
  }
  label{
    color:rgb(150,150,150);
    font-weight:100;
  }
  p{
    font-size: 14px;
  }
  .banner {
    height:150px;
    width:100%;
    background-size:cover;
    background-position:bottom;
    position:relative;
    margin-bottom:30px;
    .overlay{
      position:absolute;
      top:0px;
      left:0px;
      background:rgba(0,0,0,0.3);
      height:100%;
      width:100%;
      padding:20px 5%;
      h2{
        font-style:italic;
        font-weight:300;
        font-size:300%;
        text-transform:uppercase;
        color:white;
        text-shadow:0px 0px 5px #000;
        small{
          color:white;
          text-transform: none;
        }
      }
    }
  }
  .cover{
    background-size:cover;
    background-position: center;
    position:absolute;
    top:0px;
    left:0px;
    height:100%;
    width:100%;
    .overlay{
      z-index:20;
      position:absolute;
      top:0px;
      left:0px;
      width:100%;
      height:100%;
      color: #fff;
      background: rgba(0,0,0,0.3);
      &.with-gradient{
        background: -webkit-linear-gradient(bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.4)); /* For Safari 5.1 to 6.0 */
        background: -o-linear-gradient(bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.4)); /* For Opera 11.1 to 12.0 */
        background: -moz-linear-gradient(bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.4)); /* For Firefox 3.6 to 15 */
        background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.4)); /* Standard syntax (must be last) */
      }
      .details{
        position:absolute;
        bottom:20%;
        left:5%;
        h1{
          font-size:400%;
          font-weight: 100;
          color:white;
          text-shadow: 0px 0px 5px #000;
          text-transform: uppercase;
        }
      }
    }
  }
`;

export const PresentSlide = ({
  idea, title, subtitle, shown, children,
}) => (
  <Slide className={`${shown ? 'shown' : ''}`}>
    <div className="banner" style={{ backgroundImage: `url(${idea.coverImageUrl})` }}>
      <div className="overlay">
        <h2>
          {title}
          {subtitle
            && <span><br /><small>{subtitle}</small></span>
          }
        </h2>
      </div>
    </div>
    <div className="slide-content">
      {children}
    </div>
  </Slide>
);

export const buildSlides = (idea) => {
  const slides = [];
  if (!idea) { return slides; }
  slides.push(
    <Slide className={'shown'}>
      <div className="cover" style={{ backgroundImage: `url(${idea.coverImageUrl})` }}>
        <div className="overlay with-gradient">
          <div className="details">
            <h1>{idea.name}</h1>
            {idea.authors && idea.authors.map((author) => <UserChip key={author._id} user={author} />)}
          </div>
        </div>
      </div>
    </Slide>,
  );
  if (idea.conceptRoughIdea || idea.conceptSupportingImage) {
    slides.push(
      <PresentSlide idea={idea} title='The idea' shown>
        <p style={{ marginBottom: 20, textAlign: 'center' }}>
          {idea.conceptKeywords && idea.conceptKeywords.map((word) => <Label tag>#{word}</Label>)}
        </p>
        <Grid stackable centered>
          {idea.conceptSupportingImage
            && <Grid.Column computer={8}>
              <img alt='Concept support' src={idea.conceptSupportingImage} style={{
                maxWidth: '100%', maxHeight: 300, display: 'block', margin: '30px auto',
              }} />
            </Grid.Column>}
          {idea.conceptRoughIdea
            && <Grid.Column computer={8}>
              <RichTextViewer content={idea.conceptRoughIdea} />
            </Grid.Column>}
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.conceptVideo) {
    slides.push(
      <PresentSlide idea={idea} title='The idea' shown>
        <Grid stackable centered>
          <Grid.Column computer={10}>
            <Video forType='idea' forItem={idea} src={idea.conceptVideo} />
          </Grid.Column>
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.customersPeople?.length > 0) {
    slides.push(
      <PresentSlide idea={idea} title='Customer personas' shown>
        <Card.Group stackable itemsPerRow={3}>
          {idea.customersPeople?.filter((c) => c.nickname).map((customer, i) => <Card key={i}>
            {customer.portrait && <Image src={customer.portrait} />}
            <Card.Content>
              <Card.Header>{customer.nickname}</Card.Header>
              <Card.Meta>{customer.age}, {customer.job}</Card.Meta>
            </Card.Content>

            {customer.preferences && customer.preferences.length > 0
              && <Card.Content extra textAlign='right'>
                <Icon name='heart' /> {customer.preferences.join(', ')}
              </Card.Content>}
          </Card>)}
        </Card.Group>
      </PresentSlide>,
    );
  }

  if (idea.customersMarket || idea.customersStrategy) {
    slides.push(
      <PresentSlide idea={idea} title='Marketing strategy' shown>
        <Grid stackable centered>
          {idea.customersMarket
            && <Grid.Column computer={8} textAlign='center'>
              <h3>The market</h3>
              <RichTextViewer content={idea.customersMarket} />
            </Grid.Column>}
          {idea.customersStrategy
            && <Grid.Column computer={8} textAlign='center'>
              <h3>Marketing mix</h3>
              <RichTextViewer content={idea.customersStrategy} />
            </Grid.Column>}
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.competitors?.length > 0) {
    slides.push(
      <PresentSlide idea={idea} title='Key competitors' subtitle='Basic SWOT analysis' shown>
        <Grid centered>
          <Grid.Row>
            {idea.competitors?.filter((c) => c.name || c.logo).map((competitor, i) => <Grid.Column computer={5} key={i}>
              <Card>
                {competitor.logo && <Image src={competitor.logo} />}
                <Card.Content>
                  <Card.Header>{competitor.name}</Card.Header>
                  {competitor.website && <Card.Meta><a href={util.ensureHttp(competitor.website)} target='_blank' rel="noopener noreferrer">{competitor.website}</a></Card.Meta>}
                </Card.Content>
              </Card>
            </Grid.Column>)}
          </Grid.Row>
          <Grid.Row>
            {idea.competitors?.filter((c) => c.name || c.logo).map((competitor, i) => <Grid.Column computer={5} key={i}>
              {competitor.goodPoints && <>
                <p><strong>Strong points</strong></p>
                <RichTextViewer content={competitor.goodPoints} />
              </>}
              {competitor.badPoints && <>
                <p><strong>Weak points</strong></p>
                <RichTextViewer content={competitor.badPoints} />
              </>}
            </Grid.Column>)}
          </Grid.Row>
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.competitorsStrategy) {
    slides.push(
      <PresentSlide idea={idea} title='The opportunity' subtitle='Unique selling point' shown>
        <div style={{ textAlign: 'center' }}>
          <h3>What makes {idea.name} different?</h3>
          <Grid centered stackable>
            <Grid.Column computer={8}>
              <RichTextViewer content={idea.competitorsStrategy} />
            </Grid.Column>
          </Grid>
        </div>
      </PresentSlide>,
    );
  }
  if (idea.compatibilityPeople?.length > 0) {
    slides.push(
      <PresentSlide idea={idea} title='Management team' subtitle='Overview' shown>
        <Grid centered stackable>
          {idea.compatibilityPeople?.filter((p) => p.portrait || p.name).map((person, i) => person.name
            && <Grid.Column computer={5}>
              <Card key={i}>
                {person.portrait && <Image src={person.portrait} />}
                <Card.Content>
                  <Card.Header>{person.name}</Card.Header>
                  {person.role && <Card.Meta>{person.role}</Card.Meta>}
                </Card.Content>
                {person.description
                  && <Card.Content meta>
                    <RichTextViewer content={person.description} />
                  </Card.Content>}
              </Card>
            </Grid.Column>)}
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.compatibilityPassion) {
    let total = 0;
    if (idea.compatibilityPassion) { total += idea.compatibilityPassion.rating || 0; }
    if (idea.compatibilityBelief) { total += idea.compatibilityBelief.rating || 0; }
    if (idea.compatibilityHistory) { total += idea.compatibilityHistory.rating || 0; }
    if (idea.compatibilityRisk) { total += idea.compatibilityRisk.rating || 0; }
    if (idea.compatibilityNetwork) { total += idea.compatibilityNetwork.rating || 0; }
    const score = parseInt((total * 10) / 5, 10);
    slides.push(<PresentSlide idea={idea} title='Management team' subtitle='Self-evaluation' shown>
      <Grid stackable centered className='ratings' style={{ textAlign: 'center' }}>
        <Grid.Column computer={3}>
          <h2>Passion</h2>
          <h3>{idea.compatibilityPassion ? idea.compatibilityPassion.rating : 0}</h3>
          <MultiLineParagraph content={idea.compatibilityPassion?.notes} />
        </Grid.Column>
        <Grid.Column computer={3}>
          <h2>Resilience</h2>
          <h3>{idea.compatibilityBelief ? idea.compatibilityBelief.rating : 0}</h3>
          <MultiLineParagraph content={idea.compatibilityBelief?.notes} />
        </Grid.Column>
        <Grid.Column computer={3}>
          <h2>Communication</h2>
          <h3>{idea.compatibilityHistory ? idea.compatibilityHistory.rating : 0}</h3>
          <MultiLineParagraph content={idea.compatibilityHistory?.notes} />
        </Grid.Column>
        <Grid.Column computer={3}>
          <h2>Planning</h2>
          <h3>{idea.compatibilityRisk ? idea.compatibilityRisk.rating : 0}</h3>
          <MultiLineParagraph content={idea.compatibilityRisk?.notes} />
        </Grid.Column>
        <Grid.Column computer={3}>
          <h2>Network</h2>
          <h3>{idea.compatibilityNetwork ? idea.compatibilityNetwork.rating : 0}</h3>
          <p>{idea.compatibilityNetwork && idea.compatibilityNetwork.notes}</p>
        </Grid.Column>
      </Grid>
      <h2 style={{ textAlign: 'center' }}>
        We're {score}% compatible with this idea
      </h2>
    </PresentSlide>);
  }
  if (idea.contentsOverview?.length > 0) {
    slides.push(
      <PresentSlide idea={idea} title='Operations' shown>
        <Grid stackable centered>
          {idea.contentsOverview && idea.contentsOverview.map((item, i) => <Grid.Column computer={4} tablet={5} key={i} textAlign='center'>
            <h1>{overviewComponents.filter((c) => c.key === item.key)[0]?.icon}</h1>
            <h3 style={{ fontWeight: 'bolder' }}>{(item.title || '').toUpperCase()}</h3>
            <MultiLineParagraph content={item.description} />
          </Grid.Column>)}
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.contentsWho || idea.contentsWhat || idea.contentsWhere) {
    slides.push(
      <PresentSlide idea={idea} title='Operations' shown>
        <Grid centered stackable>
          {idea.contentsWho
            && <Grid.Column computer={5}>
              <h3>Who we need</h3>
              <RichTextViewer content={idea.contentsWho} />
            </Grid.Column>}
          {idea.contentsWhat
            && <Grid.Column computer={5}>
              <h3>What we need</h3>
              <RichTextViewer content={idea.contentsWhat} />
            </Grid.Column>}
          {idea.contentsWhere
            && <Grid.Column computer={5}>
              <h3>Where we need</h3>
              <RichTextViewer content={idea.contentsWhere} />
            </Grid.Column>}
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.contentsAdditionalInfo) {
    slides.push(
      <PresentSlide idea={idea} title='Operations' shown>
        <Grid stackable centered>
          <Grid.Column computer={8}>
            <h3>Extras</h3>
            <RichTextViewer content={idea.contentsAdditionalInfo} />
          </Grid.Column>
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.cashMoneyIn || idea.cashMoneyOut) {
    slides.push(
      <PresentSlide idea={idea} title='Finance' shown>
        <Grid centered stackable>
          {idea.cashMoneyIn
            && <Grid.Column computer={8}>
              <h3>Income</h3>
              <RichTextViewer content={idea.cashMoneyIn} />
            </Grid.Column>}
          {idea.cashMoneyOut
            && <Grid.Column computer={8}>
              <h3>Expenditure</h3>
              <RichTextViewer content={idea.cashMoneyOut} />
            </Grid.Column>}
        </Grid>
      </PresentSlide>,
    );
  }
  if (idea.cashFundingNotes) {
    slides.push(
      <PresentSlide idea={idea} title='Funding' shown>
        <Grid stackable centered>
          <Grid.Column computer={8}>
            <RichTextViewer content={idea.cashFundingNotes} />
          </Grid.Column>
        </Grid>
      </PresentSlide>,
    );
  }

  slides.push(
    <Slide className={'shown'}>
      <div className="cover" style={{ backgroundImage: `url(${idea.coverImageUrl})` }}>
        <div className="overlay with-gradient">
          <div className="details">
            <h1>{idea.name}</h1>
            <h3>Thanks for listening</h3>
          </div>
        </div>
      </div>
    </Slide>,
  );
  return slides;
};
